import { Component } from "@angular/core";

@Component({
	templateUrl: "./process.component.html",
})
export class ProcessComponent {}
